<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    ModalConsumibles(v-show="modalStatus" :consumible="consumibleToModal" @padre:close="cerrarModal")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 {{ almacenSelect === 'g' ? 'Almacenes GIA' : 'Almacenes Cedes'}} &nbsp
              |
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to='/Inventario')
                i.fas.fa-times
            br
        .columns
          .column.is-1
            router-link.a.button.is-black(to="/Inventario/Alta" v-show="!filter_actual")
              | Nuevo
          .column.is-4(v-show="!filter_actual")
            .columns(v-show="almacenSelect === 'g'")
              .column
                input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='query')
                label.is-size-6(for='tpaH') TPA
                input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='query')
                label.is-size-6(for='eb04H') EB04
                input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='query')
                label.is-size-6(for='corpH') CORP.
            .columns(v-show="almacenSelect === 'c'")
              .column
                input#irgeC.is-checkradio.is-black(type='radio', value='IRGEc' v-model='query')
                label.is-size-6(for='irgeC') IRGE
                input#tpaC.is-checkradio.is-black(type='radio', value='TPAc' v-model='query')
                label.is-size-6(for='tpaC') TPA
                input#corpC.is-checkradio.is-black(type='radio', value='CORPc' v-model='query')
                label.is-size-6(for='corpC') CORP.
          .column.is-2(v-show="!filter_actual")
            input#checkCons.is-checkradio.is-black(type='checkbox', value='CONSUMIBLE' v-model='filter_actual')
            label.is-size-6(for='checkCons') Consumibles
          .column.is-offset-4.is-3(v-show="filter_actual")
            input#checkCons.is-checkradio.is-black(type='checkbox', value='CONSUMIBLE' v-model='filter_actual')
            label.is-size-6(for='checkCons') Consumibles
            a.button.is-black.is-rounded.is-small(@click="addConsumible")
              i.fas.fa-cart-plus
            | &nbsp
            a.button.is-warning.is-rounded.is-small(@click="backConsumible")
              i.fas.fa-undo-alt
          .column.is-1
            a.button.is-success.is-rounded(@click="descargarInventario")
              span.icon.is-small
                i.fas.fa-download
              span Excel
          .column.is-3
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca|Categoría|Modelo|Serie',
                  v-model="query_articulos",
                )
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12(v-show="!filter_actual")
            TbArticulos(:articulos="articulosShow" @showChildrens="showChildrens" v-show="!verChildrens")
            TbChildrens(:childrens="childrens" :filter='query' v-show="verChildrens" @hideChildrens="hideChildrens" @updateChildrens="updateChildrens")
          .column.is-12.has-text-centered(v-show="filter_actual")
            TbConsumibles(:consumibles="consumiblesShow" @showModalConsumible='showModalConsumible')
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-warning No existen Registros.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import TbArticulos from './TbArticulos.vue'
import TbConsumibles from './TbConsumibles.vue'
import TbChildrens from './TbChildrens.vue'
import ModalConsumibles from './shared/ModalConsumibles.vue'
import { mapState } from 'vuex'

export default {
  name: 'Articulos',
  components: { Loader, NavBarInventario, TbArticulos, TbConsumibles, TbChildrens, ModalConsumibles },
  data () {
    return {
      isLoading: true,
      articulos: [],
      articulosUser: [],
      articulosSelect: [],
      articulosShow: [],
      hayDatos: false,
      limit: 0,
      query: 'ALL',
      mostrarPrevNext: false,
      query_articulos: '',
      consumibles: [],
      consumiblesSelect: [],
      consumiblesShow: [],
      filter_actual: false,
      isAdmin: false,
      isAlmacenistaGIA: false,
      isAlmacenista: false,
      childrens: [],
      result_query: '',
      modalStatus: false,
      consumibleToModal: {},
      salidasConsumible: [],
      verChildrens: false
    }
  },
  watch: {
    query() {
      if (this.query != null) {
        if (this.filter_actual) {
        } else {
          switch (this.query) {
            case 'TPA':
              this.articulosShow = this.articulosUser.filter( a => a.exist_TPA > 0 )
              break
            case 'EB04':
              this.articulosShow = this.articulosUser.filter( a => a.exist_EB04 > 0 )
              break
            case 'CORP':
              this.articulosShow = this.articulosUser.filter( a => a.exist_CORP > 0 )
              break
            case 'TPAc':
              this.articulosShow = this.articulosUser.filter( a => a.exist_TPAc > 0 )
              break
            case 'CORPc':
              this.articulosShow = this.articulosUser.filter( a => a.exist_CORPc > 0 )
              break
            case 'IRGEc':
              this.articulosShow = this.articulosUser.filter( a => a.exist_IRGEc > 0 )
              break
            default:
              this.articulosShow = this.articulosUser
              break
          }
        }
      }
    },
    filter_actual () {
      if (this.userLogin.categoria <= 0) {
        this.query = 'EB04'
      }
    },
    query_articulos () {
      const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
      if (!this.filter_actual) {
        const artFilter = this.articulosUser.filter( arts => {
          
          return `${arts.modelo} ${arts.marca} ${arts.categoria} ${arts.subcategoria}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        this.articulosShow = artFilter
        if (this.query_articulos !== '') {
          this.result_query = this.articulosShow.length === 1 ? `Se encontró ${this.articulosShow.length} coincidencia.` : `Se encontraron ${this.articulosShow.length} coincidencias.`
        } else {
          this.result_query = ''
        }
      } else {
        const consFilter = this.consumibles.filter( cons => { 
          return `${cons.modelo} ${cons.marca} ${cons.categoria} ${cons.subcategoria}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        this.consumiblesShow = consFilter
        if (this.query_articulos !== '') {
          this.result_query = this.consumiblesShow.length === 1 ? `Se encontró ${this.consumiblesShow.length} coincidencia.` : `Se encontraron ${this.consumiblesShow.length} coincidencias.`
        } else {
          this.result_query = ''
        }
      }
    }
  },
  methods: {
    iniciarComponente () {
      this.isLoading = true
      switch (this.userLogin.categoria) {
        case 0:
          this.isAdmin = true
          break
        case 1:
          this.isAdmin = false
          break
        case 2:
          this.isAdmin = true
          break
        case 3:
          this.isAdmin = false
          if (this.userLogin.cargo === '331' || this.userLogin.cargo === '332') {
            this.isAlmacenistaGIA = true
          } else {
            this.isAlmacenistaGIA = false
            if (this.userLogin.cargo === '321' || this.userLogin.cargo === '323') {
              this.isAlmacenista = true
            } else {
              this.isAlmacenista = false
            }
          }
          break
        default:
          this.isAdmin = false
          this.isAlmacenistaGIA = false
          break
      }

      if (this.isAdmin) {
        this.query = 'EB04'
      } else {
        if (this.almacenSelect === 'g') {
          this.query = this.userLogin.ubicacion === 'CORPORATIVO' ? 'CORP' : this.userLogin.ubicacion
        } else {
          this.query = `${this.userLogin.ubicacion}c`
        }
      }
      this.obtenerArticulos()
      this.obtenerConsumibles()
    },
    
    obtenerArticulos () {

      if (this.almacenSelect === 'g') {
        InventarioServices.getArticulosUbicacion('ALL')
          .then(res => {
            this.articulos = res.map(this.convetirArticulos)
            if (this.articulos.length > 0) {
              this.hayDatos = true
              switch (this.userLogin.categoria) {
                case 0:
                  this.articulosUser = this.articulos
                  this.articulosSelect = this.articulosUser
                  this.articulosShow = this.articulosUser
                  break
                case 2:
                  this.articulosUser = this.articulos
                  this.articulosSelect = this.articulosUser
                  this.articulosShow = this.articulosUser
                  break
                case 3:
                  this.articulosUser = this.articulos
                  if (this.userLogin.cargo === '331' || this.userLogin.cargo === '332' || this.userLogin.cargo === '323') {
                    switch (this.userLogin.ubicacion) {
                      case 'TPA':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_TPA > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_TPA > 0 )
                        break
                      case 'EB04':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_EB04 > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_EB04 > 0 )
                        break
                      case 'CORPORATIVO':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_CORP > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_CORP > 0 )
                        break
                    
                      default:
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_EB04 > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_EB04 > 0 )
                        break
                    }
                  } else {
                    this.articulosSelect = this.articulosUser
                    this.articulosShow = this.articulosSelect
                  }
                  break
              
                default:
                  this.articulosUser = this.articulos.filter( arts => arts.idResguardo === this.userLogin.id)
                  this.articulosShow = this.articulosUser
                  break
              }
              this.isLoading = false              
            } else {
              this.isLoading = false
              this.hayDatos = false
            }
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      } else {

        InventarioServices.getArticulosCede('ALL')
          .then(res => {
            this.articulos = res.map(this.convetirArticulos)
            if (this.articulos.length > 0) {
              this.hayDatos = true
              switch (this.userLogin.categoria) {
                case 0:
                  this.articulosUser = this.articulos
                  this.articulosSelect = this.articulosUser
                  this.articulosShow = this.articulosUser
                  break
                case 2:
                  this.articulosUser = this.articulos
                  this.articulosSelect = this.articulosUser
                  this.articulosShow = this.articulosUser
                  break
                case 3:
                  this.articulosUser = this.articulos
                  if (this.userLogin.cargo === '331' || this.userLogin.cargo === '332' || this.userLogin.cargo === '323') {
                    switch (this.userLogin.ubicacion) {
                      case 'TPAc':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_TPAc > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_TPAc > 0 )
                        break
                      case 'CORPc':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_CORPc > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_CORPc > 0 )
                        break
                      case 'IRGEc':
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_IRGEc > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_IRGEc > 0 )
                        break
                    
                      default:
                        this.articulosSelect = this.articulosUser.filter( a => a.exist_EB04c > 0 )
                        this.articulosShow = this.articulosUser.filter( a => a.exist_EB04c > 0 )
                        break
                    }
                  } else {
                    this.articulosSelect = this.articulosUser
                    this.articulosShow = this.articulosSelect
                  }
                  break
              
                default:
                  this.articulosUser = this.articulos.filter( arts => arts.idResguardo === this.userLogin.id)
                  this.articulosShow = this.articulosUser
                  break
              }
              this.isLoading = false
            } else {
              this.hayDatos = false
              this.isLoading = false
            }
            this.isLoading = false
            
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      }

    },
    convetirArticulos(data) {
      return {
        ...data,
        exist_CORP: parseInt(data.exist_CORP),
        exist_TPA: parseInt(data.exist_TPA),
        exist_EB04: parseInt(data.exist_EB04),
        exist_CORPc: parseInt(data.exist_CORPc),
        exist_TPAc: parseInt(data.exist_TPAc),
        exist_EB04c: parseInt(data.exist_EB04c),
        exist_IRGEc: parseInt(data.exist_IRGEc),
        exist_Total: parseInt(data.exist_Total),
      }
    },
    descargarInventario () {
      this.isLoading = true
      let nombreFile = ''
      let ubication = ''

      if (this.filter_actual) {
        if (this.isAdmin) {
          switch (this.query) {
            case 'ALL':
              nombreFile = 'Consumibles_General'
              ubication = 'ALL'
            break
            case 'EB04':
              nombreFile = 'Consumibles_EB04'
              ubication = 'EB04'
              break
            case 'TPA':
              nombreFile = 'Consumibles_TPA'
              ubication = 'TPA'
              break
            case 'CORP':
              nombreFile = 'Consumibles_Corporativo'
              ubication = 'CORP'
              break
            case 'IRGE':
              nombreFile = 'Consumibles_IRGE'
              ubication = 'IRGE'
              break
          }

        } else {
          switch (this.userLogin.ubicacion) {
            case 'ALL':
              nombreFile = 'Consumibles_General'
              ubication = 'ALL'
            break
            case 'EB04':
              nombreFile = 'Consumibles_EB04'
              ubication = 'EB04'
              break
            case 'TPA':
              nombreFile = 'Consumibles_TPA'
              ubication = 'TPA'
              break
            case 'CORPORATIVO':
              nombreFile = 'Consumibles_Corporativo'
              ubication = 'CORP'
              break
            case 'IRGE':
              nombreFile = 'Consumibles_IRGE'
              ubication = 'IRGE'
              break
          }
        }

        InventarioServices.createExcel_consumibles(ubication, nombreFile)
          .then((res) => {
            var currentUrl = window.location.hostname

            let api_url = ''

            if (currentUrl === '10.121.40.125') {
              api_url = '10.121.40.125'
            } else {
              api_url = '10.121.50.145'
            }


            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
              setTimeout(() => {
                InventarioServices.borrarInventario_Ubicacion(res.file)
                  .then( resDel => {
                    console.log(resDel)
                    this.isLoading = false
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast(e.message, 'ban', 'OK')
                  })
              }, 4000)
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
              
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })

        this.isLoading = false
      } else {
        console.log('Descargar Inventario de Articulos')
        switch (this.query) {
        case 'ALL':
          nombreFile = 'Inventario_General'
          break
        case 'EB04':
          nombreFile = 'Inventario_EB04'
          break
        case 'TPA':
          nombreFile = 'Inventario_GIA_TPA'
          break
        case 'TPAc':
          nombreFile = 'Inventario_TPA'
          break
        case 'CORP':
          nombreFile = 'Inventario_GIA_Corporativo'
          break
        case 'CORPc':
          nombreFile = 'Inventario_Corporativo'
          break
        case 'IRGEc':
          nombreFile = 'Inventario_IRGE'
          break
        }
        InventarioServices.createExcel_ubicacion(this.query, nombreFile)
          .then( res => {
            console.log(res)
            var currentUrl = window.location.hostname
            console.log(currentUrl)

            let api_url = ''

            if (currentUrl === '10.121.40.125') {
              api_url = '10.121.40.125'
            } else {
              api_url = '10.121.50.145'
            }


            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
              setTimeout(() => {
                InventarioServices.borrarInventario_Ubicacion(res.file)
                  .then( resDel => {
                    console.log(resDel)
                    this.isLoading = false
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast(e.message, 'ban', 'OK')
                  })
              }, 4000)
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      }

      

    },
    obtenerConsumibles() {
      InventarioServices.getConsumibles()
        .then(res => {
          this.consumibles = res.map(this.convertConsumible)
          this.consumiblesSelect = this.consumibles
          this.consumiblesShow = this.consumibles
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast(e.message, 'ban', 'OK')
        })
    },
    convertConsumible(data) {
      return {
        ...data,
        id: parseInt(data.id),
        exist_CORPO: parseInt(data.exist_CORPO),
        exist_TPA: parseInt(data.exist_TPA),
        exist_EB04: parseInt(data.exist_EB04),
        exist_IRGEc: parseInt(data.exist_IRGEc),
        exist_TPAc: parseInt(data.exist_TPAc),
        exist_CORPOc: parseInt(data.exist_CORPOc),
        exist_EB00c: parseInt(data.exist_EB00c),
        exist_EB01c: parseInt(data.exist_EB01c),
        exist_EB02c: parseInt(data.exist_EB02c),
        exist_EB03c: parseInt(data.exist_EB03c),
        exist_EB04c: parseInt(data.exist_EB04c),
        exist_ERMc: parseInt(data.exist_ERMc),
        limite: parseInt(data.limite)
      }
    },
    addConsumible () {
      this.$router.push('/Inventario/Consumibles/Nuevo')
    },
    backConsumible () {
      this.$router.push('/Inventario/Consumibles/Reingreso')
    },
    showChildrens (childrens) {
      this.isLoading = true
      this.childrens = []
      InventarioServices.getArticulos_Items(childrens.id_artBase, 'ALL')
        .then( data => {
          console.log(data)
          this.childrens = data.map(this.convertChildren)
          this.verChildrens = true
          this.isLoading = false
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
        })
    },
    
    updateChildrens (articulo) {
      console.log('Here')
      if (Object.keys(articulo).length > 0) {
        this.showChildrens(articulo)
      }
    },

    convertChildren(child) {
      return {
        ...child,
        idSAP: child.idSAP === '' ? '' : parseInt(child.idSAP),
        id_artBase: parseInt(child.id_artBase),
        tipoAdm: parseInt(child.tipoAdm),
        garantia: parseInt(child.garantia),
        estado: parseInt(child.estado),
        precioUnitario: Number(child.precioUnitario),
      }
    },
    hideChildrens (val) {
      if (val === 'update') {
        console.log('Here')
        this.isLoading = true
        this.obtenerArticulos()
        this.verChildrens = false
        this.childrens = []
      } else {
        console.log('Here2')
        this.verChildrens = false
        this.childrens = []
      }

    },
    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : null,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    showModalConsumible(cons) {
      
      InventarioServices.getConsumibles_Out(cons.id, cons.filter)
        .then( data => {
          this.salidasConsumible = data
          cons['salidas'] = data
          this.consumibleToModal = cons
        })
        .catch( e => {
          this.consumibleToModal = {}
          this.displayToast(e.message, 'ban', 'OK')
        })
      this.modalStatus = true
    },
    cerrarModal() {
      this.modalStatus = false
      this.consumibleToModal = {}
    },
    convertirDataSalidas(data) {
      return {
        ...data,
        cantidad_e: parsent(data.cantidad_e),
        cantidad_r: parsent(data.cantidad_r),
        cantidad_t: parsent(data.cantidad_t),
      }
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['userLogin', 'almacenSelect'])
  }
}
</script>

<style lang="css" scoped>

  .column-blanco {
    padding-bottom: 100px;
  }
  
  .table-responsive {
    overflow-x: auto;
    margin: 10px auto;
  }
</style>





// WEBPACK FOOTER //
// src/components/inventario_Componentes/Articulos.vue